var map = {
	"./css-logo.png": 8293,
	"./docker-logo.png": 5777,
	"./git-logo.png": 3523,
	"./html-logo.png": 1819,
	"./javascript-logo.png": 4136,
	"./mysql-logo.png": 5548,
	"./php-logo.png": 6241,
	"./symfony-logo.png": 872,
	"./vue-logo.png": 4660,
	"./wordpress-logo.png": 1087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9677;